module.exports = __webpack_public_path__ + "static/img/no_receipt.b0c4c1e1.png";